import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { NgModel, NgForm } from '@angular/forms';
import { EventManager, JhiLanguageService, AlertService } from 'ng-jhipster';

import { EventReservation } from './event-reservation.model';
import { EventReservationPopupService } from './event-reservation-popup.service';
import { EventReservationService } from './event-reservation.service';
import { Payment, PaymentService, PaymentType} from '../payment';
import { PaymentItem, PaymentItemService} from '../payment-item';
import { studentGlobalLocations } from '../../shared/constants/student.locations.constants';
import { Student, StudentService, StudentTypeaheadService } from '../student';
import { CRUD_ACTIONS, Principal } from '../../shared';
import { AbstractDialogComponent } from '../abstract-dialog-component/abstract-dialog.component';
import { School, SchoolService } from '../school';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
    selector: 'jhi-event-reservation-pay-dialog',
    templateUrl: './event-reservation-pay-dialog.component.html'
})
export class EventReservationPayDialogComponent extends AbstractDialogComponent implements OnInit, OnDestroy  {

    eventReservation: EventReservation;
    payment: Payment;
    paymentItem: PaymentItem;
    isSaving: boolean;

    search = this.studentTypeaheadService.search;
    resultFormatter = this.studentTypeaheadService.resultFormatter;
    inputFormatter = (student: any) => this.studentTypeaheadService.inputFormatter(student, () => this.payment.payer['user']);

    // Variables to handle internal or external payments
    action: string;
    readonly REGISTER_INTERNAL_PAYMENT = 'REGISTER_INTERNAL_PAYMENT';
    readonly MARK_AS_PAYED_EXTERNALLY = 'MARK_AS_PAYED_EXTERNALLY';
    private showPayedExternallyHelp: boolean;
    private showPayedInternallyHelp: boolean;

    constructor(
        private jhiLanguageService: JhiLanguageService,
        private eventReservationService: EventReservationService,
        public activeModal: NgbActiveModal,
        public studentTypeaheadService: StudentTypeaheadService,
        public schoolService: SchoolService,
        public alertService: AlertService,
        public principal: Principal,
        public paymentService: PaymentService,
        public paymentItemService: PaymentItemService,
        private eventManager: EventManager
    ) {
        super(schoolService, alertService, principal);
        this.jhiLanguageService.setLocations(['event', 'eventStatus',
            'eventCategory', 'eventReservation',
            'eventReservationStatus',
            'payment', 'paymentItem', 'paymentType',
            'student', 'user-management']);
    }

    clear() {
        this.isSaving = false;
        this.activeModal.dismiss('cancel');
    }

    save(form: NgForm) {
        if (this.payment.payer instanceof Object) {
            this.isSaving = true;

            if (this.action === this.REGISTER_INTERNAL_PAYMENT) {
                // create a new payment
                this.paymentService.create(this.payment)
                    .subscribe((res: Payment) =>
                        this.onPaymentSaveSuccess(res, CRUD_ACTIONS.CREATE),
                        (res: HttpErrorResponse) => this.onSaveError(res));
            }

            if (this.action === this.MARK_AS_PAYED_EXTERNALLY) {
                // update the reservation as payed externally
                this.eventReservation.payedExternally = true;
                this.eventReservationService.update(this.eventReservation)
                    .subscribe((res: EventReservation) =>
                        this.onEventReservationSaveSuccess(res),
                        (res: HttpErrorResponse) => this.onSaveError(res));
            }


            return;
        }

        let payerInput = form !== undefined ? form.controls['payer'] : null;
        if (payerInput !== null) {
            payerInput.reset();
        }
    }

    private onPaymentSaveSuccess(result: Payment, action: string) {
        this.paymentItem.payment = result;
        this.paymentItemService.create(this.paymentItem)
                .subscribe((res: PaymentItem) =>
                    this.onPaymentItemSaveSuccess(res),
                    (res: HttpErrorResponse) => this.onSaveError(res));
    }

    private onPaymentItemSaveSuccess(result: PaymentItem) {
        this.eventReservation.totalPaid += this.paymentItem.amount;
        this.eventManager.broadcast({ name: 'eventParticipantsListModification',  content: {
            action: CRUD_ACTIONS.UPDATE,
            content: this.eventReservation
        } });
        this.eventManager.broadcast({ name: 'paymentItemListModification',  content: {
            action: CRUD_ACTIONS.CREATE,
            content: result
        } });
        this.isSaving = false;
        this.activeModal.dismiss(result);
    }

    private onEventReservationSaveSuccess(result: EventReservation) {
            this.eventManager.broadcast({ name: 'eventParticipantsListModification',
                content: {
                    action: CRUD_ACTIONS.UPDATE,
                    content: result
                }
            });

            this.isSaving = false;
            this.activeModal.dismiss(result);
        }


    private onSaveError(error) {
        this.isSaving = false;
        this.onError(error);
    }

    private handlePaymentActionClick() {
       this.showPayedExternallyHelp = !this.showPayedExternallyHelp;
       this.showPayedInternallyHelp = !this.showPayedInternallyHelp;
    }

    ngOnInit() {
        this.payment = new Payment();
        this.payment.payer = this.eventReservation.student;
        let today: Date = new Date();
        this.payment.paymentDate = {
            year: today.getFullYear(),
            month: today.getMonth() + 1,
            day: today.getDate()
        };
        this.paymentItem = new PaymentItem();
        this.paymentItem.beneficiary = this.eventReservation.student;
        this.paymentItem.eventReservation = this.eventReservation;

        if (this.eventReservation.event) {
            this.action = this.REGISTER_INTERNAL_PAYMENT;
            this.showPayedExternallyHelp = false;
            this.showPayedInternallyHelp = true;
        }
    }

    ngOnDestroy() {

    }

}

@Component({
    selector: 'jhi-event-reservation-pay-popup',
    template: ''
})
export class EventReservationPayPopupComponent implements OnInit, OnDestroy {

    modalRef: NgbModalRef;
    routeSub: any;

    constructor(
        private route: ActivatedRoute,
        private eventreservationPopupService: EventReservationPopupService
    ) { }

    ngOnInit() {
        this.routeSub = this.route.params.subscribe(params => {
            this.modalRef = this.eventreservationPopupService
                .open(EventReservationPayDialogComponent as Component, params['id']);
        });
    }

    ngOnDestroy() {
        this.routeSub.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/event-reservation/event-reservation-pay-dialog.component.ts